import { render, staticRenderFns } from "./myDownload.vue?vue&type=template&id=8822384c&scoped=true"
import script from "./myDownload.vue?vue&type=script&lang=js"
export * from "./myDownload.vue?vue&type=script&lang=js"
import style0 from "./myDownload.vue?vue&type=style&index=0&id=8822384c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8822384c",
  null
  
)

export default component.exports